import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

/**
 * This component will display a numeric value defined with the "data"
 * attribute. A user can click the value and edit it. The component will
 * emit an event if the value was changed.
 *
 * This component detects all changes manually for performance reasons,
 * if you decide to modify it in the future please remember to call
 * detect changes when something alters the view.
 *
 * Currently this component only supports the "number" input type. 
 */
@Component({
  selector: 'click-to-edit',
  templateUrl: './click-to-edit.component.html',
  styleUrls: ['./click-to-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClickToEditComponent implements OnInit, AfterViewInit{
  
  @Input() data: number;
  @Output() dataChanged: EventEmitter<number> = new EventEmitter();
  @Input() alignRight: boolean = false;
  @Input() editable: boolean = true;
  @Input() LuStatusID:number;
  @Input() major: boolean;
  @Input() minor: boolean;
  editing: boolean = false;
  @Input() disable_decimal: boolean = false;
  @Input() isInterp: boolean = false;


  constructor(private _cdr: ChangeDetectorRef) { }

  ngOnInit() {
    console.log("Lustst",this.LuStatusID);
  }

  ngAfterViewInit() {
    this._cdr.detach();
  }

  /**
   * When the user clicks on the text value and
   * wants to edit it, call this. 
   */
  public onTextClicked() {
    if(this.LuStatusID!=7){
    this.editing = true;
    }
    
    this._cdr.detectChanges();
  }

  /**
   * When the user clicks out of the number input, hide the
   * input box unless the value has been changed. 
   * @param {number} value The value in the number input box. 
   */
  public onInputBlur(value: any) {
    if (value == this.data) {
      this.editing = false;
      this._cdr.detectChanges();
    }
  }

  /**
   * When the user clicks the cancel icon, hide the
   * number input and don't update the value. 
   */
  public onCancelClicked() {
    this.editing = false;
    this._cdr.detectChanges();
  }

  /**
   * When the user clicks save, if they have changed the
   * value in the input, emit that the value has changed as
   * an event. Also hide the input.
   * @param {any} value The value in the number input.
   */
  public onSaveClicked(value: any) {
    console.log("value",value)
    if (this.data != value) {
      this.data = value;
      this.dataChanged.emit(value);
    }
    this.editing = false;
    this._cdr.detectChanges();
  }

  GetOnlyDecimal(event:any){
    console.log("event", event)
    return event.charCode >= 48 && event.charCode <= 57
  }
  
}

